'use client';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '../../Components/Layout/Layout';
import styles from './success.module.css';
import FloatingMarquee from '@/app/shop/components/FloatingMarquee';
import gsap from 'gsap';

export default function OrderSuccess() {

  useEffect(() => {
    gsap.to("#marqueeWrapper", { autoAlpha: 1 })
  }, []);

  return (
    <Layout>
      <div className={styles.container}>
        <FloatingMarquee />
        <div className={styles.card}>
          <div className={styles.iconWrapper}>
            <div className={styles.checkmark}>✓</div>
          </div>

          <h1 className={styles.title}>Thank you for your order!</h1>

          <p className={styles.orderNumber}>
            Order № <span>122</span>
          </p>

          <p className={styles.message}>
            Our manager will contact you within 15 minutes
          </p>

          <div className={styles.actions}>
            <Link href="/" className={styles.homeBtn}>
              Home Page
            </Link>
            <Link href="/shop" className={styles.catalogBtn}>
              Continue Shopping →
            </Link>
          </div>
        </div>

        <div className={styles.productsPreview}>
          <h3 className={styles.previewTitle}>Special for you</h3>
          <div className={styles.previewGrid}>
            {[
              { name: 'ZINC', image: 'https://longevity20155.sirv.com/zinc/1.webp' },
              { name: 'MINCI', image: 'https://longevity20155.sirv.com/minci/1.webp' },
              { name: 'TESTO', image: 'https://longevity20155.sirv.com/testo/1.webp' },
            ].map((product, idx) => (
              <div key={idx} className={styles.previewItem}>
                <Image
                  src={product.image}
                  alt={product.name}
                  width={150}
                  height={150}
                  unoptimized
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}